import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import TrackPageView from './components/TrackPageView';
import AnalyticsWrapper from './components/AnalyticsWrapper';
import './index.css'; // Aquí importas Tailwind

AnalyticsWrapper.initialize();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <TrackPageView />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);